import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { KPlayerDTO } from '@envclient/envengine/src/envs/koenigsburg/KPlayer';
import { KEnvDTO } from '@envclient/envengine/src/envs/koenigsburg/KEnv';
import classes from './KPlayerItem.module.scss';
import { PlayerItemProps } from '../../components/PlayerList';
import { RootState } from 'reducers/store';
import { colorMap } from '../ccson/CcsonPlayerItem';
import { computePredictedScores } from './predictedScore';

/**
 * Koenigsburg specific PlayerItem impl - adds the predicted score (sum of earnable points from
 * cities this player is currently leading, see predictedScore.ts) on top of the base display shared
 * with CcsonPlayerItem (name, current score, turn timer, missed-turn count).
 */
const KPlayerItem: FC<KPlayerItemProps> = (props) => {
  const { player, timeLeft, actPlayer, gameStatus } = props;
  const isActive = actPlayer ? player.id === actPlayer.id : false;
  const playerColor = colorMap[player.color].code;
  const playerStyle = { color: playerColor };

  const env = useSelector<RootState>((state) => state.game.env) as KEnvDTO;

  const predictedScores = useMemo(() => computePredictedScores(env.clone), [env]);
  const predictedScore = predictedScores[player.id] ?? 0;

  return (
    <div key={player.id} className={classes.player} style={playerStyle}>
      <div className={classes.displayName}>{player.displayName} </div>
      <div className={classes.score}>{player.score} points</div>
      {predictedScore > 0 && <div className={classes.predictedScore}>+{predictedScore} predicted</div>}
      <div className={classes.active}>{isActive && gameStatus === 'PLAYING' && timeLeft}</div>
      {player.inactiveCount > 0 && <div className={classes.misses}>{player.inactiveCount} missed</div>}
    </div>
  );
};

interface KPlayerItemProps extends PlayerItemProps {
  player: KPlayerDTO;
  actPlayer: KPlayerDTO;
}

export default KPlayerItem;
